"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphabetStringUppercase = void 0;
const AlphabetString_1 = require("./AlphabetString");
exports.alphabetStringUppercase = AlphabetString_1.alphabetString.toUpperCase();
